<template>
  <Head :title="'Direct Mail - ' + formattedTabName" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <direct-mail-home 
            :client="client" 
            :user="auth.user"
            :layouts="layouts" 
            :appeals="appeals" 
            :connections="connections" 
            :datablends="datablends" 
            :census_connections="census_connections" 
            :segments="segments"
          ></direct-mail-home>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';
import { computed } from 'vue';

const props = defineProps({
  client: Object,
  auth: Object,
  layouts: Array,
  appeals: Array,
  tab_name: String,
  data_blend: Object,
  datablends: Array,
  connections: Array,
  census_connections: Array,
  segments: Array
});

const formattedTabName = computed(() => {
  if (!props.tab_name) return '';
  return props.tab_name.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
});
</script>

